module.exports = __webpack_public_path__ + "static/sanofi-logo-26ac76d2f65f30d9eb569bd12268538e.jpeg";